<script>
import Utils from "@/common/Utils";
import Constants from "@/common/Constants";
import GenericCustomAutocompleteV2 from "@/components/generic/GenericCustomAutocompleteV2"
import Service from '@/services/fiscal-notification'
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional

export default {
    components: { GenericCustomAutocompleteV2, ColumnGroup, Row },
    data: () => {
        return {
            filters: {
                from: null,
                to: null,
                productFamily: null
            },
            submitted: false,
            data: [
            ],
            loading: false,
            expandedRowGroups: [],
            movementDetailDialogVisible: false,
            movementDetail: {},
            registers: [
                {
                    "value": "38MP",
                    "valueString": null,
                    "label": "BENZENE"
                },
                {
                    "value": "20NMP",
                    "valueString": null,
                    "label": "BENZINA V.N."
                },
                {
                    "value": "20EMP",
                    "valueString": null,
                    "label": "BENZINA V.N. EXP."
                },
                {
                    "value": "43MP",
                    "valueString": null,
                    "label": "ETILENE"
                },
                {
                    "value": "44MP",
                    "valueString": null,
                    "label": "PROPILENE"
                },
                {
                    "value": "39MP",
                    "valueString": null,
                    "label": "TOLUOLO"
                }
            ],
            hter14Stock: {
                stockQuantity: null,
                stockVolume: null
            }
        }
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'versalisRegister.page_title');
    },
    created() {
    },
    computed: {
        constants: () => Constants,
        utils: () => Utils,
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        load() {

            this.submitted = true;

            if (this.filters.from && this.filters.to && this.filters.productFamily) {

                let body = {
                    from: this.filters.from,
                    to: Utils.formatEndDate(this.filters.to),
                    productFamily: this.filters.productFamily
                };

                this.loading = true;
                this.data = [];
                Service.getVersalisMovementRegister(body, response => {
                    this.loading = false;
                    if (response.success) {
                        this.data = response.data;
                        this.expandedRowGroups = this.data.map(item => `${item.voyageNumber}_${item.tankCode}`);
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });

                this.loadStock();
            }
        },
        loadStock(){
            let productFamily = this.filters.productFamily;
            
            this.hter14Stock = null;
            Service.getVersalisMovementRegisterHter14Stock({ productFamily }, response => {
                    if (response.success) {
                        this.hter14Stock = response.data;
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
        },
        downloadExcel(){
            if (this.filters.from && this.filters.to && this.filters.productFamily) {
                this.$store.dispatch("generic/setLoading", true);
                let request = {
                    from: this.filters.from,
                    to: Utils.formatEndDate(this.filters.to),
                    productFamily: this.filters.productFamily
                }
                Service.versalisMovementRegisterExcel(request, response => {
                    
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                    
                        fileLink.href = fileURL;

                        let fromStr = Utils.formatDate(Utils.dateToCurrentTimeZone(request.from));
                        let toStr = Utils.formatDate(Utils.dateToCurrentTimeZone(request.to));

                        let fileName = `${request.productFamily} ${fromStr}-${toStr}.xlsx`;
                        fileLink.setAttribute('download',fileName);
                        document.body.appendChild(fileLink);
                    
                        fileLink.click();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        groupRowsBy: (item) => `${item.voyageNumber}_${item.tankCode}`,
        openAdd(item) {

            const loadingOperation = this.data.find(x => x.voyageNumber == item.voyageNumber && x.tankCode == item.tankCode && x.operationType == 'Loading');
            this.movementDetail = {
                idLoadingOperation: loadingOperation.id,
                operationDate: null,
                movedQuantity: null,
                movedVolume: null
            }

            this.movementDetailDialogVisible = true;
        },
        openEdit(item) {

            const loadingOperation = this.data.find(x => x.voyageNumber == item.voyageNumber && x.tankCode == item.tankCode && x.operationType == 'Loading');
            this.movementDetail = {
                id: item.id,
                idLoadingOperation: loadingOperation.id,
                operationDate: Utils.dateToCurrentTimeZone(item.operationDate),
                movedQuantity: item.movedQuantity,
                movedVolume: item.movedVolume
            }

            this.movementDetailDialogVisible = true;
        },
        onDelete(item) {
            let id = item.id;

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('versalisRegister.msg.confirmDelete'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.deleteVersalisMovementRegister(id, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.load();
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onSaveMovement() {
            if (this.movementDetail.operationDate && this.movementDetail.movedQuantity && this.movementDetail.movedVolume) {
                this.$store.dispatch("generic/setLoading", true);
                if (this.movementDetail.id) {
                    Service.updateVersalisMovementRegister(this.movementDetail, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.movementDetailDialogVisible = false;
                            this.load();
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                } else {
                    Service.createVersalisMovementRegister(this.movementDetail, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.movementDetailDialogVisible = false;
                            this.load();
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                }
            }
        }
    }
}

</script>

<template>
    <main>
        <ConfirmDialog group="confirmDialog">
            <template #message="slotProps">
                <i :class="slotProps.message.icon" class="text-4xl text-primary-500 m-2"></i>
                <span v-html="slotProps.message.message" class="text-xl"></span>
            </template>
        </ConfirmDialog>

        <Dialog v-model:visible="movementDetailDialogVisible" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12">
                    <label>{{ $t('versalisRegister.unloadDate') }}</label>
                    <Calendar class="w-full" :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT" :showTime="false"
                        v-model="movementDetail.operationDate" />
                </div>
                <div class="col-12">
                    <label>{{ $t('versalisRegister.unloadWeight') }}</label>
                    <InputNumber class="w-full" inputId="integeronly" v-model="movementDetail.movedQuantity" />
                </div>
                <div class="col-12">
                    <label>{{ $t('versalisRegister.unloadVolume') }}</label>
                    <InputNumber class="w-full" inputId="integeronly" v-model="movementDetail.movedVolume" />
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="p-button p-button-outlined " label="Cancel" severity="secondary"
                    @click="movementDetailDialogVisible = false" />
                <Button type="button" label="Save" class="p-button" icon="pi pi-save" @click="onSaveMovement"
                    style="margin-left: 1rem;" />
            </div>
        </Dialog>

        <div class="formgrid grid">
            <div class="col-12 lg:col-2 field">
                <label for="from" :class="{ 'p-error': !filters.from && submitted }">{{ $t('from') }}</label>
                <Calendar :class="{ 'p-invalid': !filters.from && submitted, 'p-inputtext-sm w-full': true }"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE" :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" v-model="filters.from" :showIcon="true" :showButtonBar="true"
                    :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="to" :class="{ 'p-error': !filters.to && submitted }">{{ $t('to') }}</label>
                <Calendar :class="{ 'p-invalid': !filters.to && submitted, 'p-inputtext-sm w-full': true }"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE" :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" v-model="filters.to" :showIcon="true" :showButtonBar="true"
                    :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="familyPool" :class="{ 'p-error': !filters.productFamily && submitted }">{{
                    $t('VersalisMovements.IDREG_PROTOCOL_NUM') }}</label>
                <GenericCustomAutocompleteV2
                    :class="{ 'p-invalid': !filters.productFamily && submitted, 'w-full': true }"
                    v-model="filters.productFamily" :format="{ label: 'label', value: 'label' }"
                    :staticOptions="registers" />
            </div>
            <div class="col-12 lg:col-4 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="p-button-sm m-1" @click="load" />
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="p-button-sm p-button-outlined m-1"
                    @click="downloadExcel" />
            </div>
            <div class="col-12">
                <DataTable :value="data" :loading="loading" scrollable rowGroupMode="subheader" expandableRowGroups
                    v-model:expandedRowGroups="expandedRowGroups" show-gridlines striped-rows
                    :groupRowsBy="groupRowsBy">
                    <template #footer v-if="data.length > 0">
                        <div style="display: flex; font-weight: bold; font-size: small;">
                            <span style="flex: 10;"></span>
                            <p style="flex: 2;text-align: right;">
                                {{ $t('versalisRegister.hter14StockTotal') }}
                            </p>
                            <p style="flex: 1; text-align: right;padding-right: 1rem;">
                                {{ utils.formatInteger(hter14Stock.stockQuantity) }}
                            </p>
                            <p style="flex: 1; text-align: right;padding-right: 1rem;">
                                {{ utils.formatInteger(hter14Stock.stockVolume) }}
                            </p>
                        </div>
                    </template>
                    <template #groupheader="slotProps">
                        <div style="padding: 1rem">
                            <ResponsiveButton :label="$t('versalisRegister.unloading')" icon="pi pi-plus"
                                :disabled="!uiPermissions('VersalisMovementsRawMaterialInsertButton').isEnabled"
                                class="p-button-sm p-button-outlined" @click="openAdd(slotProps.data)" />
                            <span style="font-size: 12px; font-weight: bold; margin-left: 1rem;">
                                {{ slotProps.data.voyageNumber }} - {{ slotProps.data.vesselName }} - {{
                                    slotProps.data.tankCode }} </span>
                        </div>
                    </template>

                    <ColumnGroup type="header">
                        <Row>
                            <Column header="" />
                            <Column :header="$t('versalisRegister.loading')" :colspan="5" style="border-right: 3px solid #00CCFF;" class="center-header"/>
                            <Column :header="$t('versalisRegister.unloading')" :colspan="7" class="center-header" />
                        </Row>
                        <Row>
                            <Column header="" />
                            <Column :header="$t('versalisRegister.loadDate')" />
                            <Column :header="$t('versalisRegister.tankCode')" />
                            <Column :header="$t('versalisRegister.loadWeight')" />
                            <Column :header="$t('versalisRegister.loadVolume')" />
                            <Column :header="$t('versalisRegister.density')" style="border-right: 3px solid #00CCFF;"/>
                            <!-- <Column  /> -->
                            <Column :header="$t('versalisRegister.unloadDate')" />
                            <Column :header="$t('versalisRegister.unloadWeight')" />
                            <Column :header="$t('versalisRegister.unloadVolume')" />
                            <Column :header="$t('versalisRegister.stockQuantity')" />
                            <Column :header="$t('versalisRegister.stockVolume')" />
                            <Column :header="$t('versalisRegister.hter14StockQuantity')" />
                            <Column :header="$t('versalisRegister.hter14StockVolume')" />
                        </Row>
                    </ColumnGroup>

                    <Column>
                        <template #body="{ data }">
                            <ResponsiveButton v-if="data.operationType == 'Unloading'" icon="pi pi-pencil"
                                :disabled="!uiPermissions('VersalisMovementsRawMaterialInsertButton').isEnabled"
                                class="grid-action-btn p-button-rounded p-button-outlined m-1"
                                @click="openEdit(data)" />
                            <ResponsiveButton v-if="data.operationType == 'Unloading'" icon="pi pi-trash"
                                :disabled="!uiPermissions('VersalisMovementsRawMaterialInsertButton').isEnabled"
                                class="grid-action-btn p-button-rounded p-button-outlined m-1"
                                @click="onDelete(data)" />
                        </template>
                    </Column>
                    <Column :header="$t('versalisRegister.loadDate')">
                        <template #body="{ data }">
                            <span>{{ data.operationDate != null && data.operationType == 'Loading' ?
                                utils.formatDateTime(utils.dateToCurrentTimeZone(data.operationDate)) :
                                null }}</span>
                        </template>
                    </Column>
                    <Column field="tankCode" :header="$t('versalisRegister.tankCode')" />
                    <Column :header="$t('versalisRegister.loadWeight')">
                        <template #body="{ data }">
                            <span>{{ data.operationType == 'Loading' ? utils.formatInteger(data.movedQuantity) : null
                            }}</span>
                        </template>
                    </Column>
                    <Column :header="$t('versalisRegister.loadVolume')">
                        <template #body="{ data }">
                            <span>{{ data.operationType == 'Loading' ? utils.formatInteger(data.movedVolume) : null
                            }}</span>
                        </template>
                    </Column>
                    <Column field="density" :header="$t('versalisRegister.density')" style="border-right: 3px solid #00CCFF;">
                        <template #body="{ data }">
                            <span>{{ utils.formatDecimal(data.density, 4) }}</span>
                        </template>
                    </Column>
                    
                    <Column :header="$t('versalisRegister.unloadDate')">
                        <template #body="{ data }">
                            <span>{{ data.operationDate != null && data.operationType == 'Unloading' ?
                                utils.formatDate(utils.dateToCurrentTimeZone(data.operationDate)) :
                                null }}</span>
                        </template>
                    </Column>
                    <Column :header="$t('versalisRegister.unloadWeight')">
                        <template #body="{ data }">
                            <span>{{ data.operationType == 'Unloading' ? utils.formatInteger(data.movedQuantity) : null
                            }}</span>
                        </template>
                    </Column>
                    <Column :header="$t('versalisRegister.unloadVolume')">
                        <template #body="{ data }">
                            <span>{{ data.operationType == 'Unloading' ? utils.formatInteger(data.movedVolume) : null
                            }}</span>
                        </template>
                    </Column>
                    <Column field="stockQuantity" :header="$t('versalisRegister.stockQuantity')">
                        <template #body="{ data }">
                            <span :class="{ 'stock-negative': data.stockQuantity < 0 }">
                                {{ utils.formatInteger(data.stockQuantity) }}
                            </span>
                        </template>
                    </Column>
                    <Column field="stockVolume" :header="$t('versalisRegister.stockVolume')">
                        <template #body="{ data }">
                            <span :class="{ 'stock-negative': data.stockVolume < 0 }">
                                {{ utils.formatInteger(data.stockVolume) }}
                            </span>
                        </template>
                    </Column>
                    <Column field="hter14StockQuantity" :header="$t('versalisRegister.hter14StockQuantity')">
                        <template #body="{ data }">
                            <span>{{ utils.formatInteger(data.hter14StockQuantity) }}</span>
                        </template>
                    </Column>
                    <Column field="hter14StockVolume" :header="$t('versalisRegister.hter14StockVolume')">
                        <template #body="{ data }">
                            <span>{{ utils.formatInteger(data.hter14StockVolume) }}</span>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </main>
</template>

<style >

.center-header > div > span{
    margin: 0 auto;
}

</style>